// initial state
const state = {
  all: null,
  error: 0
}

// getters
const getters = {
  variables: state => state.all
}

// actions
const actions = {
  getVariables ({ commit }, data) {
    commit('setVariables', data)
  },
  setError ({commit}, data) {
    commit('setError', data.data)
  }
}

// mutations
const mutations = {
  setVariables (state, all) {
    state.all = all
  },
  setError (state, error) {
    state.error = {error: error, time: Date.now()}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
